import { FunctionComponent } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';

const messages = defineMessages({
  title: {
    id: 'app.updates.beta.banner.title',
    defaultMessage: 'This feature is in beta',
    description: 'Title for the beta banner on the app updates list page',
  },
  body: {
    id: 'app.updates.beta.banner.body',
    defaultMessage:
      "What's new across Atlassian is currently in beta. Browse release notes for Atlassian changes affecting your organization and track their rollout statuses. More features are on the way — including a dedicated view for reviewing Release tracks bundled releases.",
    description: 'Body text for the beta banner on the app updates list page',
  },
  link: {
    id: 'app.updates.beta.banner.link',
    defaultMessage: 'Share feedback on Community',
    description: 'Link text for the beta banner on the app updates list page',
  },
});

const COMMUNITY_POST_URL =
  'https://community.atlassian.com/forums/Community-Announcements-articles/x/ba-p/3226637';

export const BetaBanner: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <SectionMessage
      appearance="discovery"
      title={formatMessage(messages.title)}
      actions={[
        <SectionMessageAction href={COMMUNITY_POST_URL} target="_blank">
          {formatMessage(messages.link)}
        </SectionMessageAction>,
      ]}
    >
      <Text>{formatMessage(messages.body)}</Text>
    </SectionMessage>
  );
};

export default BetaBanner;
